import { graphql, fetchQuery } from 'react-relay';
import environment from 'api/environment';
import { queries_ActiveDelegatesQueryResponse } from './__generated__/queries_ActiveDelegatesQuery.graphql';
import { queries_HistoricalDelegatesQueryResponse } from './__generated__/queries_HistoricalDelegatesQuery.graphql';

const activeQuery = graphql`
  query queries_ActiveDelegatesQuery(
    $courseID: Int!
    $name: String
    $offset: Int!
    $limit: Int!
  ) {
    activeCourseTakers(
      page: { offset: $offset, limit: $limit }
      filter: { courseID: $courseID, name: $name }
    ) {
      edges {
        user {
          firstName
          lastName
          email
        }
        status
        progress {
          total
          completed
        }
      }
      pageInfo {
        total
        limit
        offset
        given
      }
    }
  }
`;

export const ActiveDelegates = async (
  courseID: number,
  page: {
    offset: number;
    limit: number;
  },
  name?: string
) => {
  const variables = {
    courseID: courseID,
    name: name,
    offset: page.offset,
    limit: page.limit
  };

  const data = (await fetchQuery(
    environment,
    activeQuery,
    variables
  )) as queries_ActiveDelegatesQueryResponse;
  if (
    !data ||
    !data.activeCourseTakers ||
    !data.activeCourseTakers.edges ||
    !data.activeCourseTakers.pageInfo
  ) {
    console.error('Could not get data', data);
  }

  return data;
};

const historicalQuery = graphql`
  query queries_HistoricalDelegatesQuery(
    $courseID: Int!
    $expiringInDays: Int
    $offset: Int!
    $limit: Int!
  ) {
    historicalCourseTakers(
      page: { limit: $limit, offset: $offset }
      filter: { courseID: $courseID, expiringInDays: $expiringInDays }
    ) {
      edges {
        user {
          firstName
          lastName
          email
        }
        certificateURL
        expiryDate
      }
      pageInfo {
        total
        limit
        offset
        given
      }
    }
  }
`;

export const HistoricalCourseTakers = async (
  courseID: number,
  page: {
    offset: number;
    limit: number;
  }
) => {
  const variables = {
    courseID: courseID,
    offset: page.offset,
    limit: page.limit
  };

  const data = (await fetchQuery(
    environment,
    historicalQuery,
    variables
  )) as queries_HistoricalDelegatesQueryResponse;
  if (
    !data ||
    !data.historicalCourseTakers ||
    !data.historicalCourseTakers.edges ||
    !data.historicalCourseTakers.pageInfo
  ) {
    console.error('Could not get data', data);
  }

  return data;
};

export const ExpiringSoonDelegates = async (
  courseID: number,
  expiringInDays: number,
  page: {
    offset: number;
    limit: number;
  }
) => {
  const variables = {
    courseID: courseID,
    expiringInDays: expiringInDays,
    offset: page.offset,
    limit: page.limit
  };

  const data = (await fetchQuery(
    environment,
    historicalQuery,
    variables
  )) as queries_HistoricalDelegatesQueryResponse;
  if (
    !data ||
    !data.historicalCourseTakers ||
    !data.historicalCourseTakers.edges ||
    !data.historicalCourseTakers.pageInfo
  ) {
    console.error('Could not get data', data);
  }

  return data;
};
